export const environment = {
  production: true,
    baseUrl: 'https://api-relaxoparivaar.relaxofootwear.com/',
  version: 'v1.0/',
    adminUrl: 'https://admin-relaxoparivaar.relaxofootwear.com/',
    platformUrl: "https://relaxoparivaar.relaxofootwear.com/",
  environmentKey: "8110B819-6F24-4570-9451-0E21AA03543D",
  nackleEnvironment: "prod",
  username: 'platform',
  password: '**********',
  gaKey: 'G-7902GZ23TY'
};
